//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { makeStyles } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import { CircularProgress } from "@material-ui/core";
import MuiPhoneNumber from "material-ui-phone-number";
import Visibility from "@material-ui/icons/Visibility";
import Select from "@material-ui/core/Select";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import CustomToolTip from "../../Global/PasswordGuileline";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import DeleteIcon from "@material-ui/icons/Delete";
import TableRow from "@material-ui/core/TableRow";
import { Switch } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
// import AddGroupTextfield from "../../views/team/groupsTextfields";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MenuItem from "@material-ui/core/MenuItem";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import DarkButton from "../../Global/DarkButton";
import LightButton from "../../Global/LightButton";
import refresh_token from "../../Global/refresh_token";
import {useTranslation} from "react-i18next";

//Custom Css + Images
import "../sites/sites.css";
import swal from "@sweetalert/with-react";
import Delete from "../../Assets/delete.png";
import Edit from "../../Assets/edit.png";
import NoRecords from '../../Assets/no_records.png'

//Redux
import { addTeam } from "../../Redux/Actions/teamAction";
import { useSelector, useDispatch } from "react-redux";
import { Route, Link, BrowserRouter } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "8px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

//Main Function
function Team() {
  const {t} = useTranslation();
  const [rowIndex, setRowIndex] = useState("");
  const [regionId, setRegionsId] = useState("");
  const [passwordLater, setPasswordLater] = useState("true");
  const [groups, setGroups] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenregion, setIsModalOpenregion] = useState(false);
  const [areas, setAreas] = useState([]);
  const [regions, setRegions] = useState([]);
  const [siteName, setSiteName] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [row, setRow] = useState([]);
  const [btnLoader, setBtnloader] = useState(false);
  const [currentCompany, setCurrentCompany] = useState("");
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [companiesArr, setCompaniesArr] = useState([]);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [signatureUrl, setSignatureUrl] = useState("");
  const [currentSiteId, setCurrentSiteId] = useState("");
  const [userData, setUserData] = useState("");
  const [token, setToken] = useState("");
  const [organizationId, setOrganizationId] = useState("");
  const [Site, setSite] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [currentEditUser, setCurrentEditUser] = useState("");
  const [group, setGroup] = useState("");
  const [teams, setTeams] = useState([]);
  const [teamData, setTeamData] = useState({
    first_name: "",
    last_name: "",
    job_title: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  let [errorObj, setErrorObj] = useState({
    first_name: "",
    last_name: "",
    job_title: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [values, setValues] = React.useState({
    showPassword: false,
    showPasswordConfirm: false,
  });
  const dispatch = useDispatch();
  const classes = useStyles();

  // useEffect(() => {
  //   let localstorage = localStorage.getItem("UserData");
  //   var data = JSON.parse(localstorage);
  //   let token = data.token;
  //   let params = {
  //     organization_id: data.organization_id,
  //   };

  //   let query = Object.keys(params)
  //     .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
  //     .join("&");

  //   fetch(GlobalApi + "/user/get_groups?" + query, {
  //     method: "GET",
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((responseJson) => responseJson.json())
  //     .then((response) => {
  //       console.log(response.data);
  //       setGroups({ groups: response.data ? response.data : [] });
  //     })
  //     .catch((error) => console.log(error));
  // }, []);

  const ModalOpenRegion = () => {
    if (currentCompany == "") {
      swal(t("Warning"), t("Select A compnay First"), "warning");
    } else {
      setIsModalOpenregion(true);
    }
  };

  const ModalOpenArea = () => {
    if (selectedRegion == "") {
      swal(t("Warning"), t("Select A Region First"), "warning");
    } else {
      setIsModalOpen(true);
    }
  };

  

  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    custommodal: {},
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

  const addnewRegion = (e, id) => {
    let form = [
      ...regions,
      {
        id: id,
        title: e,
        Areas: [],
      },
    ];
    setRegions(form);
  };

  const addnewArea = (e, id) => {
    let form = [
      ...areas,
      {
        id: id,
        title: e,
        Areas: [],
      },
    ];
    setAreas(form);
  };

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle
        disableTypography
        className="custom-modal"
        {...other}
      >
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setIsModalOpenregion(false);
              setIsModalOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);

  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);

  const addRegion = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let company_id = currentCompany.id;
    let user_id = data.user_id;

    let status = "";
     if(!group){
      swal(t("Error"), t("Region Title is Required"), "error");
      return;
    }


    let obj = {
      company_id: currentCompany.id,
      user_id: user_id,
      status: status,
      title: group,
    };

    let token = data.token;
    fetch(GlobalApi + "/Region/create_region", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("NEW REGION ADDED>>>>>>>>>>>", data);
        addnewRegion(group, data.data.id);
        setIsModalOpenregion(false);
        swal(t("Success"), t("Region Successfully Added"), "success");
      });
  };

  const addArea = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let company_id = currentCompany.id;
    let user_id = data.user_id;
    //console.log(regionid);
    let status = "active";

    if(!Site){
      swal(t("Error"), t("Area Title is Required"), "error");
      return;
    }

    let obj = {
      region_id: selectedRegion,
      title: user_id,
      status: status,
      title: Site,
    };

    let token = data.token;
    fetch(GlobalApi + "/Area/create_area", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((data) => {
        fetchregion(currentCompany);
        console.log("areas>>>>>>>>>>>>>>", areas);
        console.log("data.data>>>>>>>>>>>>>>", data);
        setAreas(data.all_areas);
        setIsModalOpen(false);
        swal(t("Success"), t("Area Successfully Added"), "success");
      });
  };

  
  const handleManagerChange = (userId) => {
    const index = users.findIndex((item) => item.user_id === userId);
    console.log(users[index]);
    setSelectedManager(userId);
    console.log(userId);
  };


  const handleRegionChange = (region) => {
    const index = regions.findIndex((item) => item.id === region);
    console.log(regions[index]);
    setSelectedRegion(region);
    setAreas(regions[index].Areas);
  };

  const handleAreaChange = (area) => {
    const index = areas.findIndex((item) => item.id === area);
    console.log(area);
    setSelectedArea(area);
  };

  const handleDeactive = (site_id) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    console.log(site_id);
    let token = data.token;
    let obj = {
      site_id,
    };
    fetch(GlobalApi + "/Site/deactivate_site", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("Response of DElete site" ,res);
        console.log("Status of DElete site" ,res.status);
        if(res.status == "Success") {
          swal(t("Success"), t("Site Successfuly deleted"), "success");
          fetchregion(currentCompany);
        } else {
          console.log(res);
          swal(t("Cannot Delete"), res.err, "warning");
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const editSite =  async (index) =>{
    setEditMode(true);
    setCurrentSiteId(row[index].site_id)
    console.log("Current Edit Site", row[index])
    setSiteName(row[index].Site);
    setAreas(row[index].All_Areas)
    setSelectedRegion(row[index].Region_id)
    setSelectedArea(row[index].Area_id)
  }

  const handleSubmit = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let user_id = data.user_id;

    if (selectedArea == "") {
      swal(t("Warning"), t("Select a Site Area"), "warning");
    } else if (selectedManager == "") {
      swal(t("Warning"), t("Select a Site Manager"), "warning");
    } else if (siteName == "") {
      swal(t("Warning"), t("Site Name is Required"), "warning");
    } else {
      setBtnloader(true);
      if (!editMode) {
        let obj = { area_id: selectedArea, user_id: user_id, title: siteName, status: "active" };
        fetch(GlobalApi + "/Site/create_site", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify(obj),
        })
          .then((response) => response.json())
          .then((data) => {
            //console.log(data);
            if (data.status == "Success" ) {
              swal(t("Success"), t("Site has been Added Successfully"), "success");
              setBtnloader(false);
              fetchregion(currentCompany);
              setSelectedArea("");
              setSelectedRegion("");
              setSiteName("");
            }
          })
          .catch((err) => {
            swal(t("Error"), "Error", "error");
            setBtnloader(false);
          });
      } else {
        let obj = { area_id: selectedArea, user_id: user_id, site_id: currentSiteId, title: siteName, status: "active" };
        fetch(GlobalApi + "/Site/edit_site", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify(obj),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("response of Edit Site", data);
            if (data.status == "Success") {
              swal(t("Success"), t("Site has been Updated Successfully"), "success");
              setBtnloader(false);
              setEditMode(false);
              fetchregion(currentCompany);
              setSelectedArea("");
              setSelectedRegion("");
              setSiteName("");
            }
          })
          .catch((err) => {
            swal(t("Error"), t("Error"), "error");
            setBtnloader(false);
          });
      }
    }

    // if (v.area.length <= 0) {
    //   swal(t("Error"), `Area is required on Row.no ${i + 1}`, "error");

    //   return;
    // } else {
    //   console.log("error");
    // }
    // if (v.site == null) {
    //   swal(t("Error"), `Site Name is required on Row.no ${i + 1}`, "error");
    //   return;
    // } else {
    //   console.log("error");
    // }
  };

  const fetchregion = (CompanyData) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);

    let token = data.token;
    console.log("TOKEN>>>>>>>", data.token);

    let params = { company_id: CompanyData.id };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(GlobalApi + "/Region/get_all_regions?" + query, {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        let form = data.data;
        console.log("REGION DATA>>>>>>>", data.data);
        setRegions(form);
        if (data.data.length > 0) {
          let arr = [];
          const data1 = data.data.map((value, index) => {
            value.Areas.map((area, i) => {
              area.Sites.map((sites, j) => {
                console.log("Value",value,"Area",area,"Sites",sites);
                let obj = {
                  company: value.company_name,
                  comapny_id:value.company_id,
                  Site: sites.title,
                  Area: area.title,
                  Area_id: area.id,
                  All_Areas:value.Areas,
                  Region: value.title,
                  Region_id: value.id,
                  site_id: sites.id,
                };
                if (sites.status !== "deactivated") {
                  arr.push(obj);
                }
              });
              setRow(arr);
              console.log("ARR<>>>>>>>>",arr)
            });
          });
        } else {
          setRow(data.data);
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  const selectCompany = (companyId) => {
    const index = companies.findIndex((item) => item.id === companyId);
    console.log(companies[index]);
    setCurrentCompany(companies[index]);
    fetchregion(companies[index]);
    fetchUsers(companies[index])
    setSelectedArea("");
    setSelectedRegion("");
    setSiteName("");
  };

  const fetchUsers = (currentCompany) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/User/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        // console.log("Response from Get Users_______________________________________________________________________________________________________________________", response);
        if (response.status == "Success") {
          setUsers(response.data);
         
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };



  let data2 = useSelector((state) => state.userReducer.user);

  useEffect(
     () => {
      setUserData(data2);
      setToken(data2.token);
      setOrganizationId(data2.organization_id);
    },
    [data2]
  );

  let data3 = useSelector((state) => state.teamReducer.team);
  console.log("data3", data3);

  useEffect(
    () => {
      setTeams(data3.data);
    },
    [data3]
  );

  let data4 = useSelector((state) => state.companyArrReducer.company);
  console.log("data4", data4);

  useEffect(
    () => {
      setCompanies(data4);
    },
    [data4]
  );

  const getTeamData = () => {
    console.log("currentCompany", currentCompany);
    let params = { company_id: currentCompany.id };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_users?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if(response.msg == "success"){
        console.log("team data updated", response);
        dispatch(addTeam(response));
        setTeams(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };

  const uploadProfileImage = async (e) => {
    let data = new FormData();
    console.log("image File", e.target.files[0]);
    await data.append("avatar", e.target.files[0]);

    console.log(data);

    try {
      let userDeactive = await fetch(GlobalApi + "/test_image_upload", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: e.target.files[0],
      });
      let response = await userDeactive.json();
      console.log("RESPONSE FROM TEST API >>>>>", response);
    } catch (error) {
      console.log("Error :::", error);
    }
  };

  return <div style={{ width: "calc(100vw -  110px)", padding: "30px 50px", overflow: "scroll" }}>
     
     <Grid  spacing={3} justifyContent="center" style={{padding:20}}> 
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <p className="label2" style={{color:Colors.globalColor8}}>{t("Add Site of Inspection")}</p>
          <br />
          <form>
          <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <>
                  <p className="label1Team">{t("Select Company to add site")}</p>
                  {!editMode ? 
                  <TextField id="outlined-select-currency" select fullWidth className={classes.textField} size="small" onChange={(e) => selectCompany(e.target.value)} name="company" InputProps={{ classes: { input: classes.resize } }} variant="outlined">
                    {companies.map((item, index) => {
                      return <MenuItem value={item.id} style={{ fontSize: 14 }}>
                          {item.company_name}
                        </MenuItem>;
                    })}
                  </TextField>:<TextField disabled id="outlined-select-currency" select fullWidth className={classes.textField} size="small" onChange={(e) => selectCompany(e.target.value)} name="company" InputProps={{ classes: { input: classes.resize } }} variant="outlined">
                    {companies.map((item, index) => {
                      return <MenuItem value={item.id} style={{ fontSize: 14 }}>
                          {item.company_name}
                        </MenuItem>;
                    })}
                  </TextField>}
                </>
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <>
                  <p className="label1Team">{t("Region")}</p>
                  {!editMode ? 
                  <Select className="SelectBox" style={{ width: "100%" } // id="demo-simple-select"
                    } value={selectedRegion} onChange={(e) => handleRegionChange(e.target.value)} variant="outlined" size="small">
                    {regions.length == 0 && <p>{t("No Regions")}</p>}
                    {regions.length > 0 && regions.map((item, index) => {
                      return <MenuItem value={item.id}>
                          {item.title}
                        </MenuItem>;
                    })}
                    
                  </Select>:<Select disabled className="SelectBox" style={{ width: "100%" } // id="demo-simple-select"
                    } value={selectedRegion} onChange={(e) => handleRegionChange(e.target.value)} variant="outlined" size="small">
                    {regions.length == 0 && <p>{t("No Regions")}</p>}
                    {regions.length > 0 && regions.map((item, index) => {
                      return <MenuItem value={item.id}>
                          {item.title}
                        </MenuItem>;
                    })}
                    
                  </Select>}

                  <div style={{ textAlign: "left",cursor:'pointer' }} onClick={() => ModalOpenRegion()}>
                      <p className="label1New" style={{ color: Colors.globalColor8, padding: "0px 10px" }}>
                        + {t("Add New Region")}
                      </p>
                    </div>
                </>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <>
                  <p className="label1Team">{t("Area")}</p>
                  <Select className="SelectBox" style={{ width: "100%" } // id="demo-simple-select"
                    } value={selectedArea} onChange={(e) => handleAreaChange(e.target.value)} variant="outlined" size="small">
                    {areas.length == 0 && <p>{t("No Areas")}</p>}
                    {areas.length > 0 &&  areas.map((item, index) => {
                      console.log("areaItem>>>>>>",item)
                      return <MenuItem value={item.id}>
                          {item.title}
                        </MenuItem>;
                    })}
                    
                  </Select>
                  <div style={{ textAlign: "left",cursor:'pointer' }} onClick={() => ModalOpenArea()}>
                      <p className="label1New" style={{ color: Colors.globalColor8, padding: "0px 10px" }}>
                        + {t("Add New Area")}
                      </p>
                    </div>
                </>
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3}>
                <>
                  <p className="label1Team">{t("Site")}</p>
                  <TextField size="small" id="outlined-basic" autoComplete="off" fullWidth value={siteName} name={t("site")} variant="outlined" className="siteTextField" onChange={(e) => setSiteName(e.target.value)} />
                </>
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3}>
                <>
                  <p className="label1Team">{t("Site Manager")}</p>
              
                  <Select className="SelectBox" style={{ width: "100%" } // id="demo-simple-select"
                    } value={selectedManager} onChange={(e) => handleManagerChange(e.target.value)} variant="outlined" size="small">
                    {users.length == 0 && <p>No Users</p>}
                    {users.length > 0 && users.map((item, index) => {
                      return <MenuItem value={item.id}>
                          {item.first_name} {" "} {item.last_name }
                        </MenuItem>;
                    })}
                    
                  </Select>
                </>
              </Grid>

            </Grid>
          </form>
        </Grid>

        <Grid item xs={12} sm={12} md={11} lg={11} style={{ marginTop: "10px" }}>
          <Button variant="contained" type="submit" className="addBtn" component="span" onClick={handleSubmit}>
          {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />}{editMode ? "Update Site":"Add Site"}
          </Button>
          &nbsp;
          <Button variant="contained" className="cancelBtn">
            {t("Cancel")}
          </Button>
        </Grid>
      </Grid>


      {/* ======================== Region Modal ===================== */}
      {isModalOpenregion != false && <div>
          <Dialog onClose={() => setIsModalOpenregion(false)} aria-labelledby="customized-dialog-title" open={true}>
            <DialogTitle id="customized-dialog-title" className="custom-modal" style={{ background: "#f5f5f5" }} onClose={() => setIsModalOpenregion(false)}>
              {t("Add New Region")}
            </DialogTitle>
            <br />
            <div style={{ padding: 20 }}>
              <TextField id="outlined-basic" name="" fullWidth size="small" error="" onChange={(e) => setGroup(e.target.value) //  value={group}
                } helperText="" className="textfield-chng" label={t("Region")} variant="outlined" />
            </div>
            <DialogActions>
              <DarkButton onClick={() => setIsModalOpenregion(false)} style={{cursor:'pointer', backgroundColor: Colors.globalColor8 }}>
                {t("Cancel")}
              </DarkButton>
              <DarkButton onClick={addRegion} style={{cursor:'pointer', backgroundColor: Colors.globalColor8 }}>
                {t("Add Region")}
              </DarkButton>
            </DialogActions>
          </Dialog>
        </div>}

      {/* ======================== Area Modal ===================== */}
      {isModalOpen != false && <div>
          <Dialog onClose={() => setIsModalOpen(false)} aria-labelledby="customized-dialog-title" open={true}>
            <DialogTitle id="customized-dialog-title" className="custom-modal" style={{ background: "#f5f5f5" }} onClose={() => setIsModalOpen(false)}>
              {t("Add New Area")}
            </DialogTitle>
            <br />
            <div style={{ padding: 10 }}>
              <TextField id="outlined-basic" name="" fullWidth size="small" error="" onChange={(e) => setSite(e.target.value) //value={Site}
                } helperText="" className="textfield-chng" label={t("Area")} variant="outlined" />
            </div>
            <DialogActions>
              <DarkButton onClick={() => setIsModalOpen(false)} style={{cursor:'pointer', backgroundColor: Colors.globalColor8 }}>
                {t("Cancel")}
              </DarkButton>
              <DarkButton onClick={addArea} style={{cursor:'pointer', backgroundColor: Colors.globalColor8 }}>
                {t("Add Area")}
              </DarkButton>
            </DialogActions>
          </Dialog>
        </div>}
    </div>;
}

export default Team;
